import { getTicketOptions } from '@/modules/Ticket/services'
import { FieldValues, Path, UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import AsyncSelectWithServer from '../AsyncSelectWithServer'

interface TicketSelectProps<T extends FieldValues> {
    control: UseFormReturn<T, any, any>['control']
    name: Path<T>
    multiple?: boolean
    showLabel?: boolean
    disabled?: boolean
    label?: string
}

const TicketSelect = <T extends FieldValues>({
    control,
    name,
    multiple,
    label,
    showLabel = true,
    disabled = false,
}: TicketSelectProps<T>) => {
    const { t } = useTranslation()
    return (
        <AsyncSelectWithServer<T>
            label={showLabel ? t(label || 'ticket') : undefined}
            placeholder={t(label || 'ticket_placeholder')}
            control={control}
            name={name}
            asyncOptions={(value) => getTicketOptions(value)}
            multiple={multiple}
            getDefaultOptions={(value) => getTicketOptions(value)}
            disabled={disabled}
        />
    )
}

export default TicketSelect
